<template>
  <div
    class="checklist__item-heading"
    @mouseover="!isDetailPage && showTools()"
    @mouseleave="!isDetailPage && hideTools()"
  >
    <template v-if="!isEditing">
      <!-- item markdown -->
      <div v-markdown="item.title" class="checklist__item-task"></div>
      <!-- item type warn -->
      <ChecklistsChecklistItemTypeWarn
        v-if="!isUserTask || isTemplatePage"
        :type="itemValues.type"
      />
    </template>
    <!-- tools box -->
    <ChecklistsToolsBox
      v-allowed:employee
      compact
      :show-tools="toolsVisible && !isEditing"
      @actionRequested="checkAction"
    />
    <!-- edit box -->

    <!-- or show tools -->
    <EditBox
      v-if="isEditing"
      :value="item.title"
      @edition-done="prepareValues"
      @close-box="closeEditBox"
    >
      <ChecklistsChecklistItemType v-model="itemValues.type" />
    </EditBox>
  </div>
</template>

<script>
// Utilities
import ChecklistsMixin from '../mixins'
// Components
import ChecklistsChecklistItemType from './ChecklistsChecklistItemType'
import ChecklistsChecklistItemTypeWarn from './ChecklistsChecklistItemTypeWarn'

export default {
  name: 'ChecklistsChecklistItemHeading',

  components: {
    ChecklistsChecklistItemType,
    ChecklistsChecklistItemTypeWarn,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  mixins: [ChecklistsMixin],

  data() {
    return {
      itemValues: {
        title: '',
        type: this.item.type,
      },
      toolsVisible: false,
    }
  },
  methods: {
    showTools() {
      this.toolsVisible = true
    },

    hideTools() {
      this.toolsVisible = false
    },

    checkAction(action) {
      if (action === 'edit') this.openEditBox()
      if (action === 'delete') this.deleteItem()
      this.hideTools()
    },

    prepareValues(title) {
      const newData = {
        title,
        type: this.itemValues.type,
      }
      // preparing requested values for API call
      const checklistInfo = this.getChecklistData({
        checklistId: this.item.checklist,
        itemId: this.item.id,
        newData: newData,
      })
      this.saveChanges(checklistInfo)
    },

    async deleteItem() {
      const { actionType, cardId, itemId, checklistId } = this.getChecklistData({
        checklistId: this.item.checklist,
        itemId: this.item.id,
      })
      this.$store.dispatch('checklists/deleteItem', { actionType, cardId, itemId, checklistId })
    },
  },

  watch: {
    changesSaved(newValue) {
      newValue && this.closeEditBox()
    },
  },
}
</script>

<style scoped>
.checklist__item-heading {
  position: relative;
  padding: 8px 8px 8px 10px;
  margin: -3px -3px -3px 0;
  z-index: 0;
}

.checklist__item-heading >>> .checklists__tools-box {
  opacity: 0;
}

.checklist__item-heading:hover >>> .checklists__tools-box {
  opacity: 1;
}

.checklist__item-task,
.checklist__item-type-warn {
  position: inherit;
  z-index: 1;
}

.app-markdown-text >>> * {
  margin: 0;
}

.checklist__item-task {
  max-width: calc(100% - 70px);
}

.checklist__item-task * {
  margin: 0;
}

.checklist__item-icon--task {
  display: flex;
  justify-content: center;
  padding-top: 4px;
  font-size: 11px;
  color: var(--c-secondary);
  width: 20px;
  height: 20px;
  border-radius: 2px;
  background-color: var(--c-secondary-400);
}
</style>
